import { useMemo } from 'react';
import { useIntl } from 'umi';
import { getName } from '@home/utils/common';
import { CardTitleMapItem } from '@/pages/dashboard/pages/monetization/type.d';

export const useCardTitle = (
  segmentValue: string,
  cardTitleMap?: Record<string, CardTitleMapItem>,
) => {
  const { formatMessage, locale } = useIntl();
  const isEN = locale === 'en-US';

  const CARD_TITLE_JSON: Record<string, string> = {
    country: formatMessage({ id: 'monetization_revenue_Revenue_of_top_10_Countries' }),
    region: formatMessage({ id: 'monetization_revenue_Revenue_of_top_10_Regions' }),
    zone: formatMessage({ id: 'monetization_revenue_Revenue_of_top_10_Zones' }),
  };

  const cardTitle = useMemo(() => {
    const mapItem = cardTitleMap?.[segmentValue];
    if (mapItem) {
      return getName(isEN, mapItem?.en, mapItem?.cn);
    }
    return CARD_TITLE_JSON[segmentValue] ?? '';
  }, [segmentValue, cardTitleMap, isEN]);

  return cardTitle;
};
